export type IndustryId =
  | 'restauracao'
  | 'retalho'
  | 'servicos'
  | 'distribuicao'
  | 'construcao'
  | 'imobiliaria'
  | 'consultoria'
  | 'tecnologia'
  | 'educacao'
  | 'ginasio'
  | 'microcredito'
  | 'saude'
  | 'transportes'
  | 'combustiveis'
  | 'other';

export interface IndustryOption {
  id: IndustryId;
  label: string;
}

export const INDUSTRIES: IndustryOption[] = [
  { id: 'restauracao', label: 'Restauração / Hotelaria' },
  { id: 'retalho', label: 'Retalho / Loja' },
  { id: 'servicos', label: 'Serviços' },
  { id: 'distribuicao', label: 'Distribuição' },
  { id: 'construcao', label: 'Construção / Engenharia' },
  { id: 'imobiliaria', label: 'Imobiliária' },
  { id: 'consultoria', label: 'Consultoria' },
  { id: 'tecnologia', label: 'Tecnologia / Agência' },
  { id: 'educacao', label: 'Educação / Formação' },
  { id: 'ginasio', label: 'Ginásio / Fitness' },
  { id: 'microcredito', label: 'Microcrédito / Financeira' },
  { id: 'saude', label: 'Saúde / Clínica' },
  { id: 'transportes', label: 'Transportes / Logística' },
  { id: 'combustiveis', label: 'Combustíveis' },
  { id: 'other', label: 'Outro / Geral' },
];

export const industryLabel = (id?: string): string => {
  const found = INDUSTRIES.find((i) => i.id === id);
  return found ? found.label : 'Outro / Geral';
};